import React, { createContext, useState, useContext, useEffect } from 'react';
import api from '../services/api';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(() => {
        try { return JSON.parse(localStorage.getItem('iiiffcn_user')); } catch { return null; }
    });

    // Revalidate token on mount
    useEffect(() => {
        const token = localStorage.getItem('iiiffcn_token');
        if (token && !user) {
            api.post('/validate-token', { token })
               .then(r => { if (r.data.status) setUser(r.data.content); else logout(); })
               .catch(logout);
        }
    }, []); // eslint-disable-line

    const signIn = async (email) => {
        const res = await api.post('/sign-in', { email });
        if (!res.data.status) throw new Error(res.data.content || 'Acesso não autorizado.');
        const userData = res.data.content;
        setUser(userData);
        localStorage.setItem('iiiffcn_user',  JSON.stringify(userData));
        localStorage.setItem('iiiffcn_token', userData.token);
        return userData;
    };

    const logout = () => {
        setUser(null);
        localStorage.removeItem('iiiffcn_user');
        localStorage.removeItem('iiiffcn_token');
    };

    const isAuthenticated = () => !!user;
    const signed = !!user; // alias used by some pages

    return (
        <AuthContext.Provider value={{ user, signed, signIn, logout, isAuthenticated }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
export default AuthContext;
